export const EledaMessagesIT = {
  undefinedOrNull: "⍰",
  true: "vero",
  false: "falso",
  submitBtn: "Convalidare",
  nextActBtn: "Attività successiva",

  defaultMessageAllSolutionsFound: {
    neutral: ["Ben fatto, hai superato l'attività 🤩"],
    kids: ["Bravo, hai completato l'attività 🤩"],
    formal: ["Congratulazioni, hai completato con successo l'attività"],
  },
  defaultMessageAllSolutionsNotFound: {
    neutral: ["Non hai trovato tutte le risposte nell'attività"],
    kids: [
      "Non hai trovato tutte le risposte nell'attività ma non scoraggiarti 😉 ",
    ],
    formal: ["Non hai trovato tutte le risposte dell'attività."],
  },

  defaultMessaggioTutteLeSoluzioniNonRitrovateMaTentativiRimasti: {
    neutral: [
      "Non hai trovato tutte le risposte dell'attività, ma puoi comunque correggere le tue risposte",
    ],
    kids: [
      "Non hai trovato tutte le risposte nell'attività ma puoi ancora correggere le tue risposte 😉 ",
    ],
    formal: [
      "Non hai trovato tutte le risposte nell'attività ma puoi ancora correggere le tue risposte",
    ],
  },

  defaultMessageAllSolutionsNotFoundButRemainedQuestions: {
    neutral: [
      "Non hai trovato tutte le risposte nell'attività ma sono rimaste delle domande",
    ],
    kids: [
      "Non hai trovato tutte le risposte nell'attività ma ci sono ancora domande 😉 ",
    ],
    formal: [
      "Non hai trovato tutte le risposte nell'attività ma ci sono ancora domande",
    ],
  },

  defaultMessageSolutionFound: {
    neutral: [
      "🟢 Congratulazioni, hai trovato la risposta giusta",
      "🟢 Corretto!",
      "🟢 Un'altra buona risposta, complimenti!",
      "🟢 Risposta corretta. Ben fatto!",
      "🟢 Esatto! Ottimo lavoro!",
      "🟢 Risposta corretta!",
      "🟢 Risposta giusta!",
    ],
    kids: [
      "🟢 Congratulazioni, hai trovato la risposta giusta",
      "🟢 Waw! Corretto!",
      "🟢 Un'altra buona risposta, complimenti!",
      "🟢 SÌ! Risposta corretta! Ben fatto!",
      "🟢 Esatto! Ottimo lavoro!",
      "🟢 Sì, continua così!",
      "🟢 È nato un nuovo genio della matematica! Risposta corretta!",
      "🟢 Woop woop ! Risposta esatta!",
    ],
    formal: [
      "🟢 Congratulazioni, hai trovato la risposta giusta",
      "🟢 Corretta!",
      "🟢 Un'altra buona risposta, complimenti!",
      "🟢 Risposta corretta. Ben fatto!",
      "🟢 Esatto!",
      "🟢 Risposta corretta",
      "🟢 Risposta giusta",
    ],
  },

  defaultMessageSolutionFoundAtFirstAttempt: {
    neutral:
      "🟢 Hai trovato la soluzione giusta al primo tentativo, complimenti!",
    kids: "🟢 Wow, ci hai azzeccato al primo tentativo!!!",
    formal: "🟢 Hai azzeccato la prima volta, complimenti",
  },

  defaultMessageSolutionNotFound: {
    neutral: [
      "🔴 Questa volta non hai trovato la soluzione...",
      "🔴 Risposta sbagliata",
      "🔴 Non è la risposta corretta...",
    ],
    kids: [
      "🔴 Questa volta non hai trovato la soluzione...",
      "🔴 Risposta sbagliata, merda! La prossima volta la troverai giusta!",
      "🔴 Non è la risposta corretta... Un po' di allenamento in più e ci riuscirai!",
    ],
    formal: [
      "🔴 Questa volta non hai trovato la soluzione...",
      "🔴 Risposta sbagliata",
      "🔴 Non è la risposta corretta...",
    ],
  },
  defaultMessageSolutionNotFoundButRemainingAttempts: {
    neutral: [
      "🟠 Non hai trovato la risposta corretta, ma proviamo di nuovo",
      "🟠 Risposta sbagliata. Puoi riprovare",
      "🟠 Risposta sbagliata... Non arrenderti e riprova",
      "🟠 Non hai capito bene, ma puoi comunque modificare la tua risposta",
      "🟠 Non è la risposta giusta... Riprova",
    ],
    kids: [
      "🟠 Non hai trovato la risposta corretta, ma riproviamo!",
      "🟠 Risposta sbagliata, peccato! Fai un respiro profondo e concentrati, la troverai giusta!",
      "🟠 Risposta sbagliata... Vai, vai, vai! Non mollare!",
      "🟠 Non hai azzeccato, ma puoi comunque modificare la tua risposta",
      "🟠 Risposta sbagliata, merda! Se correggi la risposta puoi azzeccarla!",
      "🟠 Non è la risposta giusta... Il prossimo tentativo sarà quello buono!",
      "🟠 Arg, risposta sbagliata! Non arrenderti!",
    ],
    formal: [
      "🟠 Non hai trovato la risposta corretta, ma proviamo di nuovo",
      "🟠 Risposta sbagliata. Puoi riprovare",
      "🟠 Risposta sbagliata... Non arrenderti e riprova",
      "🟠 Non hai capito bene, ma puoi comunque modificare la tua risposta",
      "🟠 Non è la risposta giusta... Riprova",
    ],
  },

  defaultMessageSolution: "La soluzione è ",

  defaultMessageMCQSolutionAnswer: "è la soluzione",
  defaultMessageReorderSolutionFound: "Tutti gli elementi sono ben ordinati",
  defaultMessageReorderSolutionNotFound:
    "Alcuni elementi sono nel posto sbagliato",
  defaultMessageAssociateSolutionFound: "Tutti gli elementi sono ben associati",
  defaultMessageAssociateSolutionNotFound:
    "Alcuni elementi sono associati erroneamente",
  questionOpenExpressionDeprecatedMode:
    "Come si scrive un'espressione matematica ?",
  questionOpenExpressionDeprecatedModeMathSymbols: `
    Usare <b>*</b> per moltiplicare. es: a*b significa a × b <br/>
    Usare <b>/</b> per frazione. es: 1/4 significa ¼ <br/>
    Usare <b>^</b> per la potenza. es: a^2 significa a²  <br/>
    Usare <b>sqrt()</b> per la radice quadrata. es: sqrt(a) significa √a
    `,

  //ERRORS used by manageErrors
  emptyMultipleChoiceQuestion:
    "Errore nella progettazione delle attività: Non c'è scelta in questa domanda",
  emptyQuestionReorder:
    "Errore nella progettazione delle attività: Non ci sono elementi da riordinare",
  notAFractionQuestionFraction:
    "Errore nella progettazione dell'attività: La risposta corretta (frazione) sembra non essere una frazione",
  emptyQuestionAssociate:
    "Errore nella progettazione dell'attività: Non ci sono elementi da associare",
  emptyQuestionOpen:
    "Errore nella progettazione dell'attività: Non c'è soluzione in questa domanda",
  notElementBoardQuestionFigure:
    "Errore nella progettazione dell'attività: In questa domanda non c'è una tavola grafica",
  notAExpressionQuestionExpression:
    "Errore nella progettazione dell'attività: La risposta corretta (espressione) non sembra essere un'espressione",
};
